import { GroupIds } from "@/configuration/group-ids";
import {
  SchedulingChannel,
  type SchedulingCustomerConfig,
  SchedulingSmsAvailabilityStrategy,
  SchedulingSmsEligibilityStrategy,
} from "@/customer-interface/scheduling";

/** Initial/established SMS booking in the mock sandbox only; live and Voice retain their current paths. */
export const heartplaceSchedulingConfig = {
  locationQuery: {
    enabledGroupIds: { [SchedulingChannel.Sms]: [GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX] },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/ushv-heartplace/rules/schedule.yaml",
  },
  sms: {
    eligibility: SchedulingSmsEligibilityStrategy.Agentic,
    eligibilityEnabledGroupIds: [GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX],
    availability: SchedulingSmsAvailabilityStrategy.AgenticProvider,
    availabilityEnabledGroupIds: [GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX],
    bookingEnabledGroupIds: [GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX],
  },
} as const satisfies SchedulingCustomerConfig;
